import StockPhysical from "@/components/pages/admin/stocks/StockPhysical";

const stocksRoutes = [
  {
    path: "/admin/stocks",
    name: "stocks",
    redirect: {
      name: "dashboard-stock-next",
    },
    meta: {
      title: "stocks",
      icon: "box",
      roles: [
        "ROLE_ADMIN",
        "ROLE_FINANCE",
        "ROLE_CLIENT",
        "ROLE_BRAND_ADMIN",
        "ROLE_BRAND_FINANCE",
      ],
      cms: ["FAUME", "SHOPIFY"],
    },
  },
  {
    path: "/admin/stocks/physique",
    name: "stocks-physical",
    component: StockPhysical,
    meta: {
      title: "stocks-physical",
      icon: "box",
      roles: [
        "ROLE_ADMIN",
        "ROLE_FINANCE",
        "ROLE_CLIENT",
        "ROLE_BRAND_ADMIN",
        "ROLE_BRAND_FINANCE",
      ],
      cms: ["FAUME", "SHOPIFY"],
    },
  },
];

export default stocksRoutes;
